import React, { useEffect, useRef, useState } from 'react';

import ReactDOM from 'react-dom';

import { TEmployerId } from '@entities/modal/model/types/employerId';
import { useDialog } from '@shared/hooks';

interface IAssignTaskToEmployeePopoverProps {
    currentClickedId: TEmployerId;
    children: React.ReactNode;
    onCloseCb?: () => void;
}

export const AssignTaskToEmployeePopover = ({
    currentClickedId,
    children,
    onCloseCb,
}: IAssignTaskToEmployeePopoverProps) => {
    const [position, setPosition] = useState<{ top: number; left: number } | null>(null);
    const popoverRef = useRef<HTMLDivElement>(null);
    const mouseDownInside = useRef(false);

    useEffect(() => {
        const handleMouseDown = (e: MouseEvent) => {
            mouseDownInside.current =
                !!popoverRef?.current && popoverRef?.current?.contains(e.target as Node);
        };

        document.addEventListener('mousedown', handleMouseDown);

        return () => {
            document.removeEventListener('mousedown', handleMouseDown);
        };
    }, []);

    useEffect(() => {
        const el = document.querySelector(`[data-employer-id="${currentClickedId}"]`);
        if (el) {
            const rect = el.getBoundingClientRect();
            setPosition({
                top: rect.top + window.scrollY + 40,
                left: rect.left + window.scrollX - 60,
            });
        }
    }, [currentClickedId]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const calendar = document.querySelector('.daterangepicker');
            if (calendar && calendar.contains(event.target as Node)) {
                return;
            }

            if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
                onCloseCb();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onCloseCb]);

    if (!position) return null;

    return ReactDOM.createPortal(
        <div
            style={{
                position: 'absolute',
                top: position.top,
                left: position.left,
                zIndex: 2000,
            }}
            ref={popoverRef}
        >
            {children}
        </div>,
        document.body
    );
};
